import * as React from 'react';
import Select from 'react-select';
import "react-widgets/styles.css";
import { Col, FormFeedback, Input, Label, Row } from 'reactstrap';
import { useAppSelector } from '../../hooks';
import { Edge, selectOE, selectSD } from '../../redux/EntitiesSlice';




const DistrictTypeSelector = (props:any) => {

    const sdSelector: any = useAppSelector(selectSD);
    const oeSelector: any = useAppSelector(selectOE);

    const defaultValue: { value: string; label: string; } = { value: '', label: '' };

    const [districtOptions, setDistrictOptions] = React.useState<Array<{ value: string; label: string; }> | []>([]);



    const IsDistrictTypeValid = (): boolean => {
        var result = false;

        if (districtOptions.length > 0) {
            if (props.selectedDistrictTypeOption.value != defaultValue.value) {
                result = true;
            }
        }
        else {
            result = true;
        }

        return result;
    }

    function addIfDistrictType(e: Edge, result: Array<{ value: string; label: string; }>) {
        var ncode: string = e.to.concept.code;
        if ((ncode.length === 6) && !isNaN(parseInt(ncode))) {
            // The code converts numerically so this is an entity and not a district type node
            return;
        }
        result.push(
            {
                value: e.to.concept.code,
                label: e.to.concept.name
            });
    }

    function setDistrictOptionsFromSelector() {

        let result: Array<{ value: string; label: string; }> = new Array<{ value: string; label: string; }>();
        result.push(defaultValue);

        if (props.selectedEntityTypeCodeOption.value == "SPECIAL_DISTRICT") {
            if (sdSelector) {
                sdSelector.map((e: any) => addIfDistrictType(e, result));
            }
        }
        else if (props.selectedEntityTypeCodeOption.value == "OTHER_ENTITY") {
            if (oeSelector) {
                oeSelector.map((e: any) => addIfDistrictType(e, result));
            }
        }
        result.sort((a, b) => a.label.localeCompare(b.label))
        setDistrictOptions(result);

        if (props.isCreateMode == false) {
            var foundInitialValue = result.find((element: { value: string; label: string }) => element.label == props.selectedDistrictTypeOption);
            if (foundInitialValue) {
                props.setSelectedDistrictTypeOption(foundInitialValue);
            }
        }
    }

    React.useEffect(() => {
        if (props.selectedEntityTypeCodeOption.value == "SPECIAL_DISTRICT" ||
            props.selectedEntityTypeCodeOption.value == "OTHER_ENTITY") {
            setDistrictOptionsFromSelector();
        }
        else {
            setDistrictOptions([]);
        }
    }, [props.selectedEntityTypeCodeOption]);

    React.useEffect(() => {

        props.setDistrictTypeIsValid(IsDistrictTypeValid())

    }, [districtOptions, props.selectedDistrictTypeOption.value])
 
    return (
        <React.Fragment>
            <Row>
                <Col >
                    <Label>District Type:</Label>
                </Col>
                <Col md="9">
                    <Select
                        value={props.selectedDistrictTypeOption}
                        onChange={(e: any) => { props.setSelectedDistrictTypeOption(e) }}
                        options={districtOptions}
                        isDisabled={
                            props.selectedEntityTypeCodeOption.value != 'SPECIAL_DISTRICT'
                            && props.selectedEntityTypeCodeOption.value != 'OTHER_ENTITY'}
                    />

                    <Input type="hidden" value={props.selectedDistrictTypeOption.value}
                        onChange={(e) => { }}
                        valid={props.districtTypeIsValid}
                        invalid={!props.districtTypeIsValid}
                        disabled={true}
                    />
                    <FormFeedback>Entity district type is required.</FormFeedback>

                </Col>
            </Row>
        </React.Fragment>
    );
}


export default DistrictTypeSelector;